import { ApiResponse } from '@marketplace-web/core-api/api-client-util'

import { api } from 'data/api/api'

import { SendFeedbackProblemFeedbackArgs } from '../types/feedback-problem'

export const sendFeedbackProblemFeedback = (args: SendFeedbackProblemFeedbackArgs) =>
  api.post<ApiResponse>(
    `/users/${args.userId}/msg_threads/${args.conversationId}/problem_options`,
    {
      problem_option_id: args.problemOptionId,
      message: args.message,
      help_center_session_id: args.helpCenterSessionId,
    },
  )
